<template>
    <div class="hospital-stats-container">
        <!-- 제목/경로 등 필요하면 상단에 추가 -->

        <!-- 날짜 검색 필터 -->
        <div class="search-filter-row">
            <input type="date" v-model="searchStart" />
            <span> ~ </span>
            <input type="date" v-model="searchEnd" />
            <button class="btn search" @click="fetchData">조회</button>
            <button class="btn print" @click="handlePrint">출력</button>
        </div>

        <!-- 병원별 사용 통계 테이블 -->
        <div class="table-area">
            <table class="hospital-stats-table">
                <thead>
                <tr>
                    <th>병원명</th>
                    <th>검사 건수</th>
                    <th>처방 건수</th>
                    <th>평균 사용 빈도</th>
                    <th>활성 사용자 수</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, idx) in hospitalStats" :key="idx">
                    <td>{{ row.name }}</td>
                    <td>{{ formatNum(row.examCount) }}</td>
                    <td>{{ formatNum(row.prescriptionCount) }}</td>
                    <td>{{ row.usageAvg }}</td>
                    <td>{{ formatNum(row.activeUser) }}</td>
                </tr>
                </tbody>
            </table>
        </div>


    </div>
</template>
<script>

</script>
